<template>
  <div id="profile-card">
    <v-card class="text-center pt-8">
      <div class="pb-8">
        <div
          class="d-inline-block profile-image-wrapper"
          style="position: relative"
        >
          <v-avatar size="128">
            <img v-if="file != ''" :src="getURL()" />
            <img v-else-if="user.profile_image" :src="user.profile_image" />
            <img v-else src="/images/default-profile.jpg" />
          </v-avatar>
          <div
            v-if="isProfile && file == '' && isMine != false"
            style="
              position: absolute;
              width: 25px;
              height: 25px;
              bottom: 5px;
              right: 5px;
              font-size: 12px;
              border-radius: 50%;
              border: 2px solid black;
              cursor: pointer;
            "
            class="red white--text d-flex align-center justify-center"
            @click="() => this.$refs.FileInput.click()"
          >
            <input
              type="file"
              ref="FileInput"
              style="display: none"
              @change="onFilePicked"
            />
            <i class="fa fa-camera"></i>
          </div>
          <div v-if="file != ''">
            <div
              style="
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
                border-radius: 50%;
                background: rgba(0, 0, 0, 0.05);
              "
              class="d-flex align-center justify-center"
            >
              <div v-if="authLoading">
                <v-progress-circular indeterminate />
              </div>

              <div
                style="
                  width: 25px;
                  height: 25px;
                  font-size: 12px;
                  border-radius: 50%;
                  border: 2px solid black;
                  cursor: pointer;
                "
                v-if="!authLoading"
                class="
                  success
                  mr-4
                  white--text
                  d-flex
                  align-center
                  justify-center
                "
                @click="lc_updateProfileImage"
              >
                <i class="fa fa-check"></i>
              </div>
              <div
                style="
                  width: 25px;
                  height: 25px;
                  font-size: 12px;
                  border-radius: 50%;
                  border: 2px solid black;
                  cursor: pointer;
                "
                v-if="!authLoading"
                @click="file = ''"
                class="red white--text d-flex align-center justify-center"
              >
                <i class="fa fa-trash"></i>
              </div>
            </div>
          </div>
          <img
            v-if="user.isVerified"
            class="verified-badge"
            src="images/verified-badge.png"
          />
        </div>
      </div>
      <h3>{{ user.firstname }} {{ user.lastname }}</h3>
      <h5>{{ user.username }}</h5>

      <v-chip
        class="ml-1"
        x-small
        v-for="(type, k) of user.creator_type"
        :key="k"
        >{{ type }}</v-chip
      >
      <br />
      <v-chip x-small>{{ user.connects.length }} Connects</v-chip>
      <br />
      <!-- <div class="d-flex card-info mt-8">
          <div class="card-info-box">
            <span class="font-weight-bold">358</span>
            <small>Connections</small>
          </div>
          <div class="card-info-box">
            <span class="font-weight-bold">85</span>
            <small>Views</small>
          </div>
        </div> -->

      <div v-if="isProfile" class="px-3 pb-3 pt-1">
        <div class="d-flex mb-2 align-center">
          <small class="font-weight-bold">Genre</small>
          <small
            :class="{ 'ml-auto': k === 0 }"
            v-for="(genre, k) of user.genre"
            :key="k"
            >{{ genre }}<span v-if="k !== user.genre.length - 1">,</span></small
          >
        </div>

        <div class="d-flex mb-2 align-center">
          <small class="font-weight-bold">Sub Genre</small>
          <small
            :class="{ 'ml-auto': k === 0 }"
            v-for="(genre, k) of user.sub_genre"
            :key="k"
            >{{ genre
            }}<span v-if="k !== user.sub_genre.length - 1">,</span></small
          >
        </div>

        <div class="text-left mb-2 d-block">
          <small class="font-weight-bold">Music Education</small>
          <div
            class="d-flex"
            v-for="(education, k) of user.music_education"
            :key="k"
          >
            <small class="ml-4">{{ education.institute }}</small>
            <small class="ml-auto"
              >{{ education.start_date }}<b class="mx-1">-</b
              >{{ education.end_date }}</small
            >
          </div>
        </div>
        <div class="d-flex mb-2">
          <small class="font-weight-bold">Country</small>
          <small class="ml-auto">{{ user.country }}</small>
        </div>
        <div class="d-flex mb-2">
          <small class="font-weight-bold">City</small>
          <small class="ml-auto">{{ user.city }}</small>
        </div>
        <div class="d-flex mb-2">
          <small class="font-weight-bold">Experience</small>
          <small class="ml-auto">{{ user.experience }}</small>
        </div>

        <!-- <v-row class="align-center py-5">
        <v-col cols="6"><img src="images/Mercury.jpg" /></v-col>
        <v-col cols="6"><img src="images/MGMRecords.png" /></v-col>
      </v-row> -->
        <div class="my-3">
          <v-btn
            x-small
            v-if="authUser && authUser.id && user.id == authUser.id"
            color="primary"
            class="my-4"
            @click="() => copyLink(authUser.id)"
            >Copy Profile Link</v-btn
          >
        </div>
        <div class="social-icons">
          <a :href="user.facebook" target="_blank">
            <v-avatar class="facebook" size="32"
              ><i class="fa fa-facebook"></i
            ></v-avatar>
          </a>
          <a :href="user.twitter" target="_blank">
            <v-avatar class="twitter" size="32"
              ><i class="fa fa-twitter"></i
            ></v-avatar>
          </a>
          <a :href="user.instagram" target="_blank">
            <v-avatar class="instagram" size="32"
              ><i class="fa fa-instagram"></i
            ></v-avatar>
          </a>
        </div>
        <div
          class="d-flex align-center justify-center mt-4"
          v-if="authUser && authUser.id && user.id != authUser.id"
        >
          <request-system :user="user" />
        </div>
      </div>
      <v-btn
        x-small
        v-if="!user.isVerified && isMine != false"
        color="primary"
        class="my-4"
        :disabled="isVerificiationPending"
        @click="verification = true"
        >Request Verification</v-btn
      >
      <br />

      <div class="px-3 my-4" v-if="isProfile && isMine != false">
        <!-- <v-col lg="6" cols="12"> -->
        <v-btn
          v-if="!authUser.subscription_plan.isActive"
          x-small
          block
          color="primary"
          to="/resubscribe"
          >Resubscribe</v-btn
        >
        <!-- </v-col> -->
        <v-btn
          x-small
          block
          color="red white--text"
          v-if="authUser.subscription_plan.isActive"
          @click="lc_unsub"
          >Unsubscribe</v-btn
        >
      </div>
      <div class="py-3" v-if="isMine != false">
        <div v-if="isProfile">
          <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            :persistent="isDialog"
            transition="dialog-bottom-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <a dark v-bind="attrs" v-on="on"> Edit </a>
            </template>
            <v-card>
              <v-toolbar dark color="primary">
                <v-btn
                  v-if="isDialog == false"
                  icon
                  dark
                  @click="dialog = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Edit Profile</v-toolbar-title>
              </v-toolbar>
              <v-container fluid>
                <div class="d-flex">
                  <v-btn
                    color="primary"
                    class="ml-auto"
                    @click="logout"
                    v-if="isDialog"
                    >Logout</v-btn
                  >
                </div>
                <v-form @submit="lc_updateProfile" ref="ref_updateProfile">
                  <v-row class="py-5">
                    <v-col md="6" cols="12">
                      <v-text-field
                        dense
                        outlined
                        label="Firstname"
                        v-model="item.firstname"
                        :rules="[myrules.required]"
                      ></v-text-field>
                    </v-col>
                    <v-col md="6" cols="12">
                      <v-text-field
                        dense
                        outlined
                        label="Lastname"
                        v-model="item.lastname"
                        :rules="[myrules.required]"
                      ></v-text-field>
                    </v-col>

                    <v-col md="6" cols="12">
                      <v-select
                        dense
                        :items="[
                          '0-1 year',
                          '1-4 years',
                          '5-10 years',
                          '10-19 years',
                          '20+ years',
                        ]"
                        outlined
                        clearable
                        label="Experience"
                        v-model="item.experience"
                        :rules="[myrules.required]"
                      ></v-select>
                    </v-col>

                    <v-col md="6" cols="12">
                      <v-autocomplete
                        v-model="item.skills"
                        :items="skills"
                        outlined
                        dense
                        label="Skills"
                        multiple
                        item-text="name"
                        item-value="name"
                        :rules="[myrules.arrayRequired]"
                      ></v-autocomplete>
                    </v-col>

                    <v-col md="6" cols="12">
                      <vue-google-autocomplete
                        id="map"
                        class="custom-component"
                        placeholder="City"
                        v-model="item.city"
                        v-on:placechanged="getAddressData"
                      >
                      </vue-google-autocomplete>
                    </v-col>
                    <v-col md="6" cols="12">
                      <v-autocomplete
                        v-model="item.country"
                        :items="[
                          'United States',
                          'United Kingdom',
                          'Canada',
                          'South America',
                          'Africa',
                          'Australia',
                          'International',
                        ]"
                        outlined
                        dense
                        label="Country"
                        :rules="[myrules.required]"
                      ></v-autocomplete>
                    </v-col>
                    <v-col md="6" cols="12">
                      <v-autocomplete
                        :items="
                          item.country == 'United States'
                            ? [
                                'All Track',
                                'ASCAP',
                                'BMI',
                                'SESAC',
                                'Sound Exchange',
                              ]
                            : item.country == 'Canada'
                            ? [
                                'SOCAN',
                                'Sound Music Licensing Company',
                                'CMRRA',
                              ]
                            : item.country == 'International'
                            ? [
                                'APRA',
                                'COTT',
                                'JASRAC',
                                'PPCA',
                                'PRS',
                                'PPL',
                                'SIAE',
                                'SACM',
                                'SAMRO',
                              ]
                            : [
                                'APRA',
                                'COTT',
                                'JASRAC',
                                'PPCA',
                                'PRS',
                                'PPL',
                                'SIAE',
                                'SACM',
                                'SAMRO',
                              ]
                        "
                        outlined
                        dense
                        :disabled="item.country == ''"
                        v-model="item.performing_rights_organization"
                        label="Performing Rights Organization"
                        multiple
                        :rules="[myrules.arrayRequired]"
                      ></v-autocomplete>
                    </v-col>
                    <v-col md="6" cols="12">
                      <v-autocomplete
                        deletable-chips
                        multiple
                        small-chips
                        solo
                        flat
                        dense
                        outlined
                        label="Genre"
                        v-model="item.genre"
                        :items="getGenre"
                        :rules="[myrules.arrayRequired]"
                      ></v-autocomplete>
                    </v-col>
                    <v-col md="6" cols="12">
                      <v-autocomplete
                        deletable-chips
                        multiple
                        small-chips
                        solo
                        flat
                        dense
                        outlined
                        label="Sub Genre"
                        :items="getGenre"
                        v-model="item.sub_genre"
                        :rules="[myrules.arrayRequired]"
                      ></v-autocomplete>
                    </v-col>
                    <v-col md="6" cols="12">
                      <v-autocomplete
                        v-model="item.creator_type"
                        :items="creator_type"
                        outlined
                        dense
                        label="Creator Type"
                        multiple
                        :rules="[myrules.arrayRequired]"
                      ></v-autocomplete>
                    </v-col>

                    <v-col md="6" cols="12">
                      <!-- <v-text-field
                      dense
                      outlined
                      label="Creating Since"
                      v-model="item.creating_since"
                      :rules="[myrules.required]"
                    ></v-text-field> -->
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="date"
                            label="Creating Since"
                            readonly
                            outlined
                            dense
                            v-bind="attrs"
                            v-on="on"
                            :rules="[myrules.arrayRequired]"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date"
                          type="month"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col md="6" cols="12">
                      <v-text-field
                        dense
                        outlined
                        label="Label"
                        v-model="item.label"
                        :rules="[myrules.required]"
                      ></v-text-field>
                    </v-col>
                    <v-col md="6" cols="12">
                      <v-combobox
                        dense
                        outlined
                        label="Sounds Like"
                        multiple
                        small-chips
                        deletable-chips
                        v-model="item.sounds_like"
                        :rules="[myrules.arrayRequired]"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12">
                      <v-switch
                        label="Email Notifications"
                        class="mb-4"
                        v-model="item.email_notifications"
                      ></v-switch>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        label="My Bio"
                        dense
                        outlined
                        v-model="item.my_bio"
                        :rules="[myrules.required]"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12">
                      <div class="d-flex align-center mb-3">
                        <label>Education</label>
                        <span class="ml-auto">
                          <v-btn
                            icon
                            class="primary white--text"
                            @click="lc_addEducationFields"
                            ><i class="fa fa-plus"></i
                          ></v-btn>
                        </span>
                      </div>
                      <div
                        v-for="(education, k) of item.music_education"
                        :key="k"
                      >
                        <v-row>
                          <v-col md="5" cols="12">
                            <v-text-field
                              label="Institute"
                              dense
                              outlined
                              v-model="education.institute"
                              :rules="[myrules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col md="3" cols="12">
                            <!-- <v-dialog
                            :ref="`dialogStartDate${k}`"
                            v-model="modal1"
                            :return-value.sync="education.start_date"
                            persistent
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                label="Start Date"
                                dense
                                outlined
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                v-model="education.start_date"
                                :rules="[myrules.required]"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="education.start_date"
                              type="month"
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="modal1 = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="lc_savedate(k, education)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-dialog> -->
                            <!-- <v-text-field
                              type="month"
                              outlined
                              dense
                              label="Start Date"
                              v-model="education.start_date"
                            /> -->
                            <v-menu
                              v-model="showPicker"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="education.start_date"
                                  label="Start Date"
                                  type="month"
                                  outlined
                                  dense
                                  persistent-hint
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="education.start_date"
                                no-title
                                type="month"
                                :max="
                                  new Date().getFullYear() +
                                  '-' +
                                  (new Date().getMonth() + 1)
                                "
                                @input="showPicker = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col md="3" cols="12">
                            <!-- <v-dialog
                            ref="dialog1"
                            v-model="modal2"
                            :return-value.sync="education.end_date"
                            persistent
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                label="End Date"
                                dense
                                outlined
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                v-model="education.end_date"
                                :rules="[myrules.required]"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="education.end_date"
                              type="month"
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="modal2 = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.dialog1.save(date)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-dialog> -->
                            <!-- <v-text-field
                              type="month"
                              outlined
                              dense
                              label="End Date"
                              v-model="education.end_date"
                            /> -->
                            <v-menu
                              v-model="showPicker1"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="education.end_date"
                                  label="End Date"
                                  type="month"
                                  outlined
                                  dense
                                  persistent-hint
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="education.end_date"
                                type="month"
                                no-title
                                :min="education.start_date"
                                @input="showPicker1 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col md="1" cols="12">
                            <v-btn
                              block
                              class="red white--text"
                              @click="lc_removeEducationField(k)"
                              :disabled="item.music_education.length == 1"
                              ><i class="fa fa-trash"></i
                            ></v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                    <!-- <v-col md="4" cols="12">
                    <v-text-field
                      dense
                      outlined
                      label="Spotify"
                      v-model="item.spotify"
                      :rules="[myrules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col md="4" cols="12">
                    <v-text-field
                      dense
                      outlined
                      label="Apple"
                      v-model="item.apple"
                      :rules="[myrules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col md="4" cols="12">
                    <v-text-field
                      dense
                      outlined
                      label="Sound Cloud"
                      v-model="item.sound_cloud"
                      :rules="[myrules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col md="6" cols="12">
                    <v-text-field
                      dense
                      outlined
                      label="Facebook"
                      v-model="item.facebook"
                      :rules="[myrules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col md="6" cols="12">
                    <v-text-field
                      dense
                      outlined
                      label="Instagram"
                      v-model="item.instagram"
                      :rules="[myrules.required]"
                    ></v-text-field>
                  </v-col> -->
                  </v-row>
                  <div class="py-1">
                    <v-btn type="submit" color="primary" :loading="authLoading"
                      >Save</v-btn
                    >
                  </div>
                </v-form>
              </v-container>
            </v-card>
          </v-dialog>
          |
          <a dark @click="logout"> Logout </a>
        </div>
        <div v-else>
          <router-link class="text-decoration-none" to="/profile"
            >View my profile</router-link
          >
        </div>
      </div>
      <v-dialog v-model="verification" width="480">
        <v-card>
          <v-card-title> Verification </v-card-title>
          <v-form
            ref="verification_ref"
            @submit="
              (e) => {
                e.preventDefault();
                sendVerification({
                  user_id: authUser.id,
                  file: verificationFile,
                });
                verification = false;
              }
            "
          >
            <div class="pa-4">
              <label class="mb-3">Select Id Card</label>
              <v-file-input
                outlined
                dense
                label="Id Card"
                v-model="verificationFile"
                :rules="[myrules.required]"
              ></v-file-input>
              <div class="d-flex justify-end">
                <v-btn color="primary" type="submit" class="mr-2">Save</v-btn>
                <v-btn color="red white--text" @click="verification = false"
                  >Cancel</v-btn
                >
              </div>
            </div>
          </v-form>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RequestSystem from "./RequestSystem.vue";
import VueGoogleAutocomplete from "vue-google-autocomplete";
export default {
  components: { RequestSystem, VueGoogleAutocomplete },
  name: "ProfileCard",
  props: ["isProfile", "isDialog", "user", "isMine"],
  data() {
    return {
      verificationFile: "",
      dialog: this.isDialog ? this.isDialog : false,
      country: null,
      file: "",
      showPicker: false,
      showPicker1: false,
      verification: "",
      menu: false,
      date: new Date().toISOString().substr(0, 7),
      modal1: false,
      modal2: false,
      item: {
        firstname: "",
        lastname: "",
        username: "",
        experience: "",
        music_education: [
          {
            institute: "",
            start_date: new Date().toISOString().substr(0, 7),
            end_date: new Date().toISOString().substr(0, 7),
          },
        ],
        email: "",
        skills: [],
        country: "",
        performing_rights_organization: [],
        genre: [],
        sub_genre: [],
        creator_type: [],
        creating_since: "",
        label: "",
        sounds_like: [],
        my_bio: "",
        city: "",
        // spotify: "",
        // apple: "",
        // sound_cloud: "",
        // facebook: "",
        // instagram: "",
      },
      skills: [
        { header: "Instruments" },
        { name: "Accordion", group: "Instruments" },
        { name: "Acoustic Guitar", group: "Instruments" },
        { name: "Bagpipes", group: "Instruments" },
        { name: "Banjo", group: "Instruments" },
        { name: "Bass Guitar", group: "Instruments" },
        { name: "Beatbox", group: "Instruments" },
        { name: "Bugle", group: "Instruments" },
        { name: "Cello", group: "Instruments" },
        { name: "Clarinet", group: "Instruments" },
        { name: "Cymbals", group: "Instruments" },
        { name: "Drums", group: "Instruments" },
        { name: "Electric Guitar", group: "Instruments" },
        { name: "Flute", group: "Instruments" },
        { name: "French Horn", group: "Instruments" },
        { name: "Harmonica", group: "Instruments" },
        { name: "Harp", group: "Instruments" },
        { name: "Keyboard", group: "Instruments" },
        { name: "Midi", group: "Instruments" },
        { name: "Organ", group: "Instruments" },
        { name: "Piano", group: "Instruments" },
        { name: "Recorder", group: "Instruments" },
        { name: "Saxophone", group: "Instruments" },
        { name: "Tambourine", group: "Instruments" },
        { name: "Triangle", group: "Instruments" },
        { name: "Trumpet", group: "Instruments" },
        { name: "Tuba", group: "Instruments" },
        { name: "Ukelele", group: "Instruments" },
        { name: "Voice", group: "Instruments" },
        { name: "Viola", group: "Instruments" },
        { name: "Violin", group: "Instruments" },
        { name: "Xylophone", group: "Instruments" },
        { divider: true },
        { header: "Composition" },
        { name: "Lyrics", group: "Composition" },
        { name: "Melody", group: "Composition" },
        { name: "Arrangement", group: "Composition" },
        { name: "Score", group: "Composition" },
        { name: "Vocal Production", group: "Composition" },
        { divider: true },
        { header: "Production" },
        { name: "Ableton", group: "Production" },
        { name: "Acid", group: "Production" },
        { name: "Cubase", group: "Production" },
        { name: "Fruity Loops", group: "Production" },
        { name: "GarageBand", group: "Production" },
        { name: "Logic Pro", group: "Production" },
        { name: "PreSonus", group: "Production" },
        { name: "Protools", group: "Production" },
        { name: "Reason", group: "Production" },
        { name: "Reaper", group: "Production" },
        { name: "StudioOne", group: "Production" },
      ],
      creator_type: ["Writer", "Song Writer", "Producer", "Composer", "Artist"],
    };
  },
  computed: {
    ...mapGetters(["getGenre"]),
  },
  methods: {
    copyLink(id){
      navigator.clipboard.writeText(`https://lyricster-pro.web.app/profile/${id}`);
      alert("Link copied to clipboard");
    },
    async lc_savedate(k, education) {
      let ref = `dialogStartDate${k}`;

      this.$refs[ref].save(education.start_date);
    },
    async lc_removeEducationField(idx) {
      this.item.music_education = this.item.music_education.filter(
        (_, k) => k != idx
      );
    },
    async lc_unsub() {
      await this.unSubscribe({
        s_id: this.authUser.subscription_id,
        id: this.authUser.id,
      });
    },
    getAddressData: function (addressData, placeResultData, id) {
      this.item.city = addressData.administrative_area_level_2;
    },
    async lc_updateProfile(e) {
      e.preventDefault();
      let validate = this.$refs.ref_updateProfile.validate();

      this.item.creating_since = this.date;

      if (validate) {
        let id = this.authUser.id;
        await this.updateProfile({ ...this.item, id });
        this.dialog = false;
      }
    },
    async lc_updateProfileImage(e) {
      e.preventDefault();
      let id = this.authUser.id;
      await this.updateProfile({ id, profile_image: this.file });
      this.file = "";
    },
    getURL() {
      return URL.createObjectURL(this.file);
    },
    onFilePicked(e) {
      this.file = e.target.files[0];
    },
    lc_addEducationFields() {
      this.item.music_education.push({
        institute: "",
        start_date: new Date().toISOString().substr(0, 7),
        end_date: new Date().toISOString().substr(0, 7),
      });
    },
  },
  beforeMount() {
    let authUser = this.authUser;
    delete authUser["last_login"];
    delete authUser["joined_datetime"];
    this.item = { ...this.item, ...authUser };
  },
};
</script>

<style>
.custom-component {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.4);
  margin-bottom: 25px;
}
.custom-component:active,
.custom-component:focus {
  border-color: #4e02fc !important;
}
.scrollable-card {
  overflow: auto;
  height: calc(100vh - 80px);
}
.profile-image-wrapper {
  position: relative;
  overflow: hidden;
}
.verified-badge {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 30px;
  height: 30px;
}
.card-info {
  height: 60px;
  border-top: 1px solid rgba(0, 0, 0, 0.4);
  border: bottom 0.3281em;
  border-top: 1px solid rgba(0, 0, 0, 0.4);
  border-bottom: 1px solid rgba(0, 0, 0, 0.4);
}
.card-info-box {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.card-info-box:first-child {
  border-right: 1px solid rgba(0, 0, 0, 0.4);
}
.social-icons a {
  text-decoration: none;
  margin: 0 5px;
}
</style>
